import { Message } from "../message.model";

export interface CountByDayData {
    Acceso: string;
    'Conversión Ingreso': number | string;
    'Conversión Salida': number | string;
    Consolidado: string;
    Entradas: number | string;
    Salidas: number | string;
    Fecha: string;
    Día: string;
    Mes: string;
    Factor?: number | string;
  }

  export interface CountByDayCameraResponse {
    column_name: {
      'public data': CountByDayData[];
    } | Message;
  }

  export interface CountByDayAccessResponse {
  fu_queryhuv333xacceso: {
    'public data': CountByDayData[];
  }  | Message;
}

  export interface CountByDayRequest {
    sucursal: string;
  }
